import React, { useState } from "react";
import {
  CalendarCheck,
  CheckCircle2,
  HelpCircle,
  MessageCircle,
  Target,
  UserCheck,
} from "lucide-react";
import FreeConsultationForm from "./FreeConsultationForm";

const BENEFITS = [
  { icon: Target, label: "Discuss your personal goals" },
  { icon: HelpCircle, label: "Understand the course structure" },
  { icon: CheckCircle2, label: "Check if it matches your experience level" },
  { icon: MessageCircle, label: "Ask questions directly to the instructor" },
  { icon: UserCheck, label: "Get guidance based on your needs" },
  { icon: CalendarCheck, label: "No obligation to book" },
];

export default function FreeConsultationSection({ context = null, className = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section
        id="free-consultation"
        className={`scroll-mt-28 bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden ${className}`}
      >
        <div className="bg-gradient-to-r from-emerald-600 to-teal-700 px-6 py-5 sm:px-8 sm:py-6 text-white">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-100">
            Meet before you commit
          </p>
          <h2 className="mt-1 text-xl sm:text-2xl font-bold tracking-tight">
            Free 15-Minute Yoga Consultation
          </h2>
          <p className="mt-2 text-sm sm:text-[15px] text-emerald-50/95 max-w-2xl leading-relaxed">
            Meet your instructor before you book. Discuss your goals, ask questions, and make sure the
            course or session is the right fit for you — completely free and with no obligation.
          </p>
        </div>

        <div className="px-6 py-6 sm:px-8 sm:py-7">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
            {BENEFITS.map(({ icon: Icon, label }) => (
              <li key={label} className="flex items-start gap-2.5 text-sm text-gray-700">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
                  <Icon size={15} strokeWidth={2} />
                </span>
                <span className="leading-snug pt-1">{label}</span>
              </li>
            ))}
          </ul>

          <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 shadow-sm shadow-emerald-200 transition-colors"
            >
              Book Free Consultation
            </button>
            <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">
              Duration: 15 minutes · Online via Zoom or Google Meet · No obligation
            </p>
          </div>
        </div>
      </section>

      <FreeConsultationForm open={open} onClose={() => setOpen(false)} context={context} />
    </>
  );
}
